import { AnswerSelectContainerProps } from '../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../state/stores/Question/AnswerModel';
import { SnapshotOut } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { useRegionInfo } from '../../../../hooks/useRegionInfo';
import { useStores } from '../../../../hooks/useStores';

const _ContainPhoneLanguage: FC<AnswerSelectContainerProps> = ({
  question,
  onPress,
  children,
}) => {
  const rootStore = useStores();
  const {
    languages,
    phoneInAllLanguage,
    localLanguagePhoneEndHour,
    localLanguagePhoneStartingHour,
    loading,
    error,
  } = useRegionInfo();
  const labels= rootStore?.language?.translate.MOBILE?.ASSISTANCE?.INSTANT_HELP;

  const lastAnswer = question?.answers?.[0]? question.answers[0] : null;
  const warning = phoneInAllLanguage
    ? undefined
    : labels?.LIMITED_NUMBER_OF_LANGUAGES.replace('{{startingHour}}', String(localLanguagePhoneStartingHour)).replace('{{endingHour}}', String(localLanguagePhoneEndHour)) || '';

  const answers = lastAnswer ? [lastAnswer] : [];
  answers.push(...languages.map((language): SnapshotOut<IAnswerModel> => ({
    _id: language,
    key: language,
    wording: labels.LANGUAGES?.[language?.toUpperCase()],
    nextKey: null,
    featureChoice: null,
    meta: null,
    specialTypeOfAnswer: false,
  })));

  return children({
    answers: answers || [],
    questionId: question._id,
    questionKey: question.key,
    onPress,
    labels: {
      ERROR: error,
      WARNING: warning,
    },
    loading,
  });
};

export const ContainPhoneLanguage = observer(_ContainPhoneLanguage);

